import React, { useMemo } from 'react';
import { useOpts } from '../../context';
import FilterSearch from '../../views/SearchLegacy/FilterSearch';
import { EventSurface } from '../../types/events';
import { getLoadAllPlatformsWithWorkdayFn } from '../../utils';
import { useGetLocalizedString } from '../../hooks/useGetLocalizedString';
export default function SearchPlatforms() {
    var getLocalizedString = useGetLocalizedString();
    var _a = useOpts(), linkTokenPayload = _a.linkTokenPayload, featureFlags = _a.featureFlags, linkToken = _a.linkToken;
    var platformType = linkTokenPayload.platformType, mode = linkTokenPayload.mode;
    var title = useMemo(function () {
        return platformType === 'time_and_attendance'
            ? getLocalizedString('WHERE_DO_YOU_LOG')
            : getLocalizedString('SEARCH_FOR_PAYROLL');
    }, [getLocalizedString, platformType]);
    // TODO-Routing: THIS SHOULD BE A HOOK
    var loadResults = useMemo(function () {
        return getLoadAllPlatformsWithWorkdayFn(mode, linkToken, featureFlags, platformType);
    }, [mode, linkToken, featureFlags, platformType]);
    // TODO-Routing: REFACTOR EVENT SURFACE TO BE ROUTER DRIVEN
    return (React.createElement(FilterSearch, { title: title, loadResults: loadResults, eventSurface: EventSurface.SEARCH_PLATFORM_ONLY }));
}
